import React from "react";
import { TCText } from "../../../components/tcText/TCText";
import { Colors } from "../../../utils/colors";
import { PlayerDetails } from "./PlayerDetails";
import { MatchResponsePayload } from "../../../apis/types";

type props = {
  match: MatchResponsePayload;
};

export const PlayerDetailsList: React.FC<props> = ({ match }) => {
  return (
    <div style={{ paddingLeft: 10, paddingRight: 10, marginTop: 10 }}>
      <TCText
        value={"Players Details"}
        style={{
          fontSize: 14,
          fontWeight: 600,
          color: Colors.grey,
          marginBottom: 10,
        }}
      />
      <PlayerDetails
        player={match.teamA.playerA}
        team="A"
        isScoreAdded={match.isScoreAdded}
      />
      <PlayerDetails
        player={match.teamA.playerB}
        team="A"
        isScoreAdded={match.isScoreAdded}
      />
      <PlayerDetails
        player={match.teamB.playerA}
        team="B"
        isScoreAdded={match.isScoreAdded}
      />
      <PlayerDetails
        player={match.teamB.playerB}
        team="B"
        isScoreAdded={match.isScoreAdded}
      />
    </div>
  );
};
